import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { environment } from './../../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-cig-wistia',
  templateUrl: './cig-wistia.component.html',
  styleUrls: ['./cig-wistia.component.scss']
})
export class CigWistiaComponent implements OnInit, OnChanges {

  @Input() profile:any;
  @Input() slides;
  @Input() author;
  @Input() videoLink;
  @Input() thumbnail_img;
  public env;
  public profiles : any;
  src;
  poster:string = '';

  constructor( private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.env = environment;
    this.profiles = this.profile;
    this.buildSrc();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['slides'] || changes['videoLink']) {
      this.buildSrc();
    }
  }

  private buildSrc(): void {
    const videoId = this.slides?.[31]?.video_link;
    if (videoId) {
      this.src = this.sanitizer.bypassSecurityTrustResourceUrl(
        'https://fast.wistia.com/embed/iframe/' + videoId + '?videoFoam=true'
      );
    }
    const rawLink = typeof this.videoLink === 'string' ? this.videoLink : null;
    if (rawLink) {
      this.videoLink = this.sanitizer.bypassSecurityTrustResourceUrl(
        'https://fast.wistia.com/embed/iframe/' + rawLink + '?videoFoam=true'
      );
    }
  }

}
